import type {
    CreateCommerceCustomerRequest,
    CreateCommerceCustomerResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const createCommerceCustomerOperation = defineCommerceOperation<
    CreateCommerceCustomerRequest,
    CreateCommerceCustomerResponse
>("commerce.customer.create");
